import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSection from 'eco-design/base/eco-section';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import { useEffect } from 'react';
import styles from './index.module.scss';

export default function PC() {
    const { t } = useLang('theProduct.Animation1');
    const { t: t1 } = useLang('theProduct.Animation1.screen1');
    const { t: t2 } = useLang('theProduct.Animation1.screen2');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const mask1 = document.querySelector(`.screen1-mask`) as HTMLElement;
                const screen1 = document.querySelector(`.screen-1`) as HTMLElement;
                const screen2 = document.querySelector(`.screen-2`) as HTMLElement;
                const screen3 = document.querySelector(`.screen-3`) as HTMLElement;
                const ani = AniContainer.create({
                    triggerElement: `.${styles.comp}`,
                    triggerHook: 0,
                    offset: 0,
                    duration: '450%',
                    onEnter: () => {
                        screen1.classList.add('enter');
                        screen2.classList.add('enter');
                        screen3.classList.add('enter');
                    },
                    onLeave: () => {
                        screen1.classList.remove('enter');
                        screen2.classList.remove('enter');
                        screen3.classList.remove('enter');
                    },
                    asyncTimeLine: [0.3, 1.4, 2.2, 2.4, 4],
                    asyncFromTo: [
                        [mask1, { opacity: 0 }, { opacity: 1 }, 1],
                        [screen1, { opacity: 1 }, { opacity: 0 }, 0.1],
                        [screen2, { opacity: 1 }, { opacity: 0 }, 0.4],
                        [screen3, { opacity: 0 }, { opacity: 1 }, 0.4],
                        [screen3, { opacity: 1 }, { opacity: 1 }, 0.5],
                    ],
                });

                return () => {
                    if (ani) AniContainer.removeScene(ani);
                };
            }, 100);
        }
    }, []);
    return (
        <div className={`${styles.comp} GtmModuleData-section`} id="wave3-D" data-section-id="wave3-D" data-section-title="Unmatched Cooling and Heating">
            <div className="range2" id="range2"></div>
            <div className="range3" id="range3"></div>
            <div className="screen-1" id="screen1">
                <div className="left">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744339839435/D1-1.jpg" />
                    <div className="text-wd screen-1-text">
                        <img src="https://websiteoss.ecoflow.com/upload/image/1744680775548/wd1.svg" loading="lazy" alt="" />
                        <span>{t('wd1')}</span>
                    </div>
                </div>
                <div className="right">
                    <EcoSection
                        label={t1('label')}
                        title={t1('title')}
                        desc={t1.rich('desc', {
                            sup: (v: string) => <sup>{v}</sup>,
                        })}
                    />
                    <EcoImg className="right-img" pc="https://websiteoss.ecoflow.com/upload/image/1744881392637/1.jpg" />
                </div>
                <div className="screen1-mask mask"></div>
            </div>
            <div className="screen-2" id="screen2">
                <div className="left">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1744339903099/D2-1.jpg" />
                    <div className="text-wd screen-2-text">
                        <img src="https://websiteoss.ecoflow.com/upload/image/1744680775716/wd2.svg" loading="lazy" alt="" />
                        <span>{t('wd2')}</span>
                    </div>
                </div>
                <div className="right">
                    <EcoSection
                        label={t2('label')}
                        title={t2('title')}
                        desc={t2.rich('desc', {
                            sup: (v: string) => <sup>{v}</sup>,
                        })}
                    />
                    <EcoImg className="right-img" pc="https://websiteoss.ecoflow.com/upload/image/1744881392177/2.jpg" />
                </div>
            </div>
            <div className="screen-3" id="screen3">
                <EcoSectionCard
                    theme="black"
                    layout="center-center"
                    isVideo={true}
                    title={t('screen3')}
                    poster="https://websiteoss.ecoflow.com/upload/image/1744880265179/%E8%A7%86%E9%A2%911.jpg"
                    pc="https://websiteoss.ecoflow.com/upload/video/1744880135071/video1.mp4"
                />
            </div>
        </div>
    );
}
